import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight, Phone, Tv, Speaker, Home, MapPin } from "lucide-react";
import { company } from "../data/mock";

const POPULAR = [
  { to: "/services/tv-installation", label: "TV Mounting", Icon: Tv, id: "tv" },
  { to: "/services/audio-installation", label: "Audio Installation", Icon: Speaker, id: "audio" },
  { to: "/service-areas", label: "Service Areas", Icon: MapPin, id: "areas" },
  { to: "/", label: "Home", Icon: Home, id: "home" },
];

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="bg-[#f5f8ff]">
      <Helmet>
        <title>Page not found | Set Up Home Theater</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <section className="max-w-[1100px] mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#3b9dff]">Error 404</p>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0a1f44] leading-tight" data-testid="not-found-title">
          This page is off the wall.
        </h1>
        <p className="mt-5 max-w-xl text-base text-slate-600">
          The link you followed may be old or mistyped. Your TV install is still one click away: get an instant price or talk to us now.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/tv-mounting-quote" data-testid="not-found-quote-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#3b9dff] hover:bg-[#2b8ae8] text-white font-semibold transition-colors">
            Get my instant quote <ArrowRight className="w-4 h-4" />
          </Link>
          <a href={company.phoneLink} data-testid="not-found-call-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#0a1f44] hover:bg-[#13306a] text-white font-semibold transition-colors">
            <Phone className="w-4 h-4" /> Call {company.phone}
          </a>
        </div>
        <h2 className="mt-14 text-base md:text-lg font-bold text-[#0a1f44]">Popular pages</h2>
        <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-3">
          {POPULAR.map(({ to, label, Icon, id }) => (
            <Link key={id} to={to} data-testid={`not-found-link-${id}`} className="group flex items-center gap-3 bg-white border border-slate-200 rounded-xl px-4 py-4 hover:border-[#3b9dff] hover:-translate-y-0.5 transition-[transform,border-color]">
              <Icon className="w-5 h-5 text-[#3b9dff]" />
              <span className="font-semibold text-[#0a1f44]">{label}</span>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
}
